<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Program Pembangunan</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button @click="cek_sasaran_add" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data">
                                    <i class="material-icons">add</i>
                                </button>
                            </span>
                            <input @keyup="cari_data()" v-model="cari_value" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
                <br>
                <div class="row">
                    <div class="col-md-4">
                        <span class="huruf_input">Periode RPJMD</span>
                        <select @change="getMisi()" v-model="filter_rpjmd" class="form-control">
                            <option value="" >-- Semua Periode --</option>
                            <option v-for="data in list_rpjmd" :key="data.rpjmd_id" v-bind:value="data.rpjmd_id">	{{data.periode}}</option>
                        </select>
                    </div>

                    <div class="col-md-4">
                        <span class="huruf_input">Pilih Misi</span>
                        <select @change="getSasaran()" v-model="filter_misi" class="form-control" :disabled="filter_rpjmd==''">
                            <option value="" >-- Semua Misi --</option>
                              <option v-for="(data) in list_misi" :key="data.misi_id" v-bind:value="data.misi_id">	&#91;	{{data.no_misi}}&#93;	{{data.uraian}}</option>
                        </select>
                    </div>

                    <div class="col-md-4">
                        <span class="huruf_input">Pilih Sasaran</span>
                        <select @change="getData()" v-model="filter_sasaran" class="form-control" :disabled="filter_misi=='' || filter_rpjmd==''">
                            <option value="" >-- Semua Sasaran --</option>
                              <option v-for="(data) in list_sasaran" :key="data.sasaran_id" v-bind:value="data.sasaran_id">	&#91; {{data.no_misi}}.{{data.no_tujuan}}.{{data.no_sasaran}} &#93;	{{data.uraian}}</option>
                        </select>
                    </div>

               </div>

        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f tabel_center">
                            <!-- <th class="tabel_center text-center" style="width: 5%">No.</th> -->
                            <th class="tabel_center text-center" style="width: 5%">Kode</th>
                            <th class="tabel_center text-center" style="width: 35%">Urusan/Bidang/Program</th>
                            <th class="tabel_center text-center" style="width: 10">Prioritas</th>
                            <th class="tabel_center text-center" style="width: 30">OPD Pelaksana</th>
                            <th class="tabel_center text-center" style="width: 20%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="cek_load_data">
                                <td colspan="5" class="text-center">
                                    <img src="images/loading-plan.gif" width="450px">
                                </td>
                            </tr>

                            <template v-for="data1 in list_data">
                                <tr class="h_isitable_bold " :key="data1.urusan_pemerintahan_id">
                                    <!-- <td class="tabel_center text-center">1.</td> -->
                                    <td class="tabel_center ">{{data1.kode_urusan}}</td>
                                    <td class="tabel_center" >{{data1.nama_urusan}}</td>
                                    <td class="tabel_center text-justify"></td>
                                    <td class="tabel_center text-justify"></td>

                                    <td class="tabel_center text-center" >

                                    </td>
                                </tr>

                                <template v-for="data2 in data1.bidang_urusan_pemerintahan">
                                    
                                    <tr class="h_isitable_bold2 " :key="data2.bidang_urusan_pemerintahan_id">
                                        <!-- <td class="tabel_center text-center">1.</td> -->
                                        <td class="tabel_center">{{data1.kode_urusan}}.{{data2.kode_bidang}}</td>
                                        <td class="tabel_center" >{{data2.nama_bidang}}</td>
                                        <td class="tabel_center text-justify"></td>
                                        <td class="tabel_center text-justify"></td>

                                        <td class="tabel_center text-center" >
                                        </td>
                                    </tr>

                                    <template v-for="data3 in data2.program_pembangunan">
                                        <tr class="h_isitable" :key="data3.program_pembangunan_id">
                                            <!-- <td class="tabel_center text-center">1.</td> -->
                                            <td class="">{{data1.kode_urusan}}.{{data2.kode_bidang}}.{{data3.program.program_kode}}</td>
                                            <td class="" >{{data3.program.program_nama}}</td>
                                            <td class=" text-justify">{{data3.prioritas_nama}}</td>
                                            <td class="tabel_center text-justify">
                                                <ul>
                                                    <li v-for="data4 in data3.relasi_program_pembangunan_skpd" :key="data4.relasi_program_pembangunan_skpd_id">
                                                        <a @click="selectInstansi(data4)" href="javascript:void(0);" data-toggle="modal" data-target="#m_jml_anggaran_indikatif" title="Atur Anggaran Program Untuk SKPD ini">
                                                            {{data4.instansi}}
                                                        </a> 
                                                        &nbsp; 
                                                        <a @click="removeIns(data4.relasi_program_pembangunan_skpd_id)" href="javascript:void(0);">
                                                            <i style="font-size:90%; color:red" class="material-icons">clear</i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </td>

                                            <td class="tabel_center text-center" >

                                                <button @click="selectData(data3)" class="btn bg-light-green btn-xs waves-effect" title="Kebijakan dan Indikator Program Pembangunan" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                                    <i class="material-icons" >control_point</i>
                                                </button>
                                                    &nbsp;
                                                <button @click="selectData(data3)" class="btn bg-light-blue btn-xs waves-effect" title="Tambah OPD Pelaksana" id="edit_data" data-toggle="modal" data-target="#m_tambah_opd">
                                                    <i class="material-icons" >account_balance</i>
                                                </button>
                                                    &nbsp;
                                                <button @click="removeData(data3.program_pembangunan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                    <i class="material-icons" >clear</i>
                                                </button>
                                            </td>
                                        </tr>
                                    </template>
                                    
                                </template>




                            </template>

                        </tbody>
                    </table>
                </div>
                <hr>

                <!-- <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr> -->
                <!-- ============================================================ MODAL ======================================================================== -->


                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-blue">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>

                                        
                                        <form @submit.prevent="addData()">
                                            <div class="modal-body">

                                                

                                                <div v-if="!cek_sasaran" class="text-center">
                                                    <span> 
                                                        <i class="material-icons col-orange">warning</i> <br>
                                                        <b>MOHON PILIH SASARAN TERLEBIH DAHULU...!!!</b>
                                                    </span>
                                                </div>

                                                <div v-if="cek_sasaran">


                                                    <div class="row clearfix">
                                                        <div class="col-md-3 form-control-label">
                                                            <label for="kode">Urusan Pemerintahan</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select @change="getBidang()" v-model="urusan_pemerintahan_id" class="form-control">
                                                                        <option v-for="data in list_urusan" :value="data.urusan_pemerintahan_id" :key="data.urusan_pemerintahan_id">[{{data.kode_urusan}}] {{data.nama_urusan}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-3 form-control-label">
                                                            <label for="kode">Bidang Urusan Pemerintahan</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select @change="getProgram" v-model="bidang_urusan_pemerintahan_id" class="form-control">
                                                                        <option v-for="data in list_bidang" :value="data.bidang_urusan_pemerintahan_id" :key="data.bidang_urusan_pemerintahan_id">[{{data.kode_bidang}}] {{data.nama_bidang}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

        
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered" style="width: 100%">
                                                            <thead>
                                                            <tr class="bg-info kepala_table_f tabel_center">

                                                                <th class="tabel_center text-center" style="width: 10%">Pilih</th>
                                                                <th class="tabel_center text-center" style="width: 10%">Kode</th>
                                                                <th class="tabel_center text-center" style="width: 80%">Program</th>
                                                                <!-- <th class="tabel_center text-center" style="width: 40%">Prioritas</th> -->
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr class="h_isitable" v-for="data in list_program" :key="data.program_id">
                                                                <td class="tabel_center text-center" >
                                                                    <input v-model="pilih_program" type="checkbox" :value="data.program_id" :id="data.program_id" class="filled-in chk-col-blue" :checked="1">
                                                                    <label :for="data.program_id"></label>
                                                                </td>
                                                                <td class="tabel_center" >{{data.program_kode}}</td>
                                                                <td class="tabel_center text-justify">{{data.program_nama}}</td>
                                                                <!-- <td class="tabel_center text-justify">
                                                                    <select v-model="prioritas_id[index]" class="form-control">
                                                                        <option value="" selected> -- Pilih Prioritas Program --</option>
                                                                        <option v-for="data in list_prioritas" :value="data.prioritas_id" :key="data.prioritas_id">{{data.prioritas_nama}}</option>
                                                                    </select>
                                                                </td> -->
                                                            </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>

    
                                                </div>
                                            </div>

                                            <div class="modal-footer">
                                                


                                                <button v-if="!cek_sasaran" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                                <button v-if="cek_sasaran" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button v-if="cek_sasaran" @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-xlg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">PENGATURAN DATA</h4>
                                    </div>

                                    <div class="modal-body">

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Kebijakan Umum</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <select v-model="kebikan_umum_id" class="form-control">
                                                            <option value="" selected> -- Pilih Kebijakan Umum Pembangunan --</option>
                                                            <option v-for="data in list_kebijakan_umum" :value="data.kebikan_umum_id" :key="data.kebikan_umum_id">[{{data.kode}}] {{data.uraian}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Prioritas Program</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <select v-model="prioritas_id" class="form-control">
                                                            <option value="" selected> -- Pilih Prioritas Program --</option>
                                                            <option v-for="data in list_prioritas" :value="data.prioritas_nama" :key="data.prioritas_id">{{data.prioritas_nama}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <hr>

                                        <button class="btn bg-light-green waves-effect" data-toggle="modal" data-target="#m_tambah_data_indikator_kinerja">
                                            Tambah Indikator
                                            </button>
                                        <br><br>
                                        <div class="table-responsive">
                                            <table class="table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="bg-success kepala_table_f tabel_center">

                                                    <th class="tabel_center text-center" rowspan="2" style="width:5%">No</th>
                                                    <th class="tabel_center text-center" rowspan="2" style="width:30%">Uraian Indikator</th>
                                                    <th class="tabel_center text-center" rowspan="2" style="width:5%">Satuan</th>
                                                    <th class="tabel_center text-center" rowspan="2" style="width:10%">Rumusan Satuan</th>

                                                    <th class="tabel_center text-center" colspan="8">Target</th>

                                                    <th class="tabel_center text-center" rowspan="2" style="width:10%">#</th>
                                                </tr>
                                                <tr class="bg-success kepala_table_f tabel_center">
                                                    <th class="tabel_center text-center" style="width:5%">Capaian Awal</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 1</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 2</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 3</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 4</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 5</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 6</th>
                                                    <th class="tabel_center text-center" style="width:5%">Kondisi Akhir</th>
                                                </tr>
                                            </thead>
                                                <tbody>
                                                <tr class="h_isitablex" v-for="data in list_indikator" :key="data.indikator_program_pembangunan_id">
                                                    <td class="tabel_center text-center">{{data.no_indikator}}</td>
                                                    <td class="tabel_center" >{{data.uraian}}</td>
                                                    <td class="tabel_center text-center">{{data.satuan}}</td>
                                                    <td class="tabel_center text-center">{{data.rumus_satuan}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.capaian_awal)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_1)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_2)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_3)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_4)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_5)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_6)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.kondisi_akhir)}}</td>

                                                    <td class="tabel_center text-center" >

                                                        <!-- <button @click="removeData(data._id)" type="button" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data"> -->
                                                            <a href="javascript:void(0);" @click="selectIndikator(data)" style="color:orange" title="Edit Data" data-toggle="modal" data-target="#m_edt_data_indikator_kinerja">
                                                                <b> <i class="material-icons" >create</i></b>
                                                            </a>
                                                            &nbsp;
                                                            <a href="javascript:void(0);" @click="removeIndikator(data.indikator_program_pembangunan_id)" style="color:red;" title="Hapus Data">
                                                                <b> <i class="material-icons" >remove_circle</i></b>
                                                            </a>
                                                        <!-- </button> -->

                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>
                                        </div>

                                        <hr>
                                        


                                    </div>
                                    <div class="modal-footer">
                                        <button @click="editData()" type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH OPD xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal" id="m_tambah_opd" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-blue">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH OPD PELAKSANA</h4>
                                    </div>
                                <form @submit.prevent="addInstansi()">
                                    <div class="modal-body">
                                        <div class="table-responsive">
                                            <table class="table table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="bg-info kepala_table_f tabel_center">
                                                    <th class="text-center" style="width: 5%">No.</th>
                                                    <th class="text-center" style="width: 20%">Kode SKPD</th>
                                                    <th class="text-center" style="width: 60%">Nama SKPD</th>
                                                    <th class="text-center" style="width: 15%">#</th>
                                                </tr>
                                                </thead>
                                                <tbody class="tabel_center" >
                                                <tr class="h_isitable" v-for="(data, index) in list_instansi" :key="data.instansi_id">
                                                    <td class="tabel_center text-center">{{index+1}}</td>
                                                    <td class="tabel_center text-center">{{data.kode}}</td>
                                                    <td class="tabel_center">{{data.instansi}}</td>

                                                    <td class="tabel_center text-center" >
                                                        <input v-model="pilih_instansi" type="checkbox" :id="data.instansi_id" :value="data" class="filled-in chk-col-blue">
                                                        <label :for="data.instansi_id"></label>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>
                                        </div>


                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH OPD xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_tambah_data_indikator_kinerja xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal" id="m_tambah_data_indikator_kinerja" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">Indikator Sasaran Pembangunan</h4>
                                    </div>
                                <form @submit.prevent="addData()">
                                    <div class="modal-body">

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">No Indikator</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.no_indikator" type="text" class="form-control" placeholder="Ex : 1">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Uraian Indikator</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.uraian" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Satuan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.satuan" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Rumusan Satuan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.rumus_satuan" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Capaian Awal</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.capaian_awal" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 1</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_1" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 2</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_2" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 3</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_3" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 4</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_4" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 5</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_5" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 6</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_6" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Kondisi Akhir</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.kondisi_akhir" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button @click="addindikator()" type="submit" class="btn bg-light-blue waves-effect" >SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_tambah_data_indikator_kinerja xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_edt_data_indikator_kinerja xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal" id="m_edt_data_indikator_kinerja" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">Indikator Sasaran Pembangunan</h4>
                                    </div>
                                    <div class="modal-body">

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">No Indikator</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.no_indikator" type="text" class="form-control" placeholder="Ex : 1">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Uraian Indikator</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.uraian" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Satuan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.satuan" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Rumusan Satuan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.rumus_satuan" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Capaian Awal</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.capaian_awal" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 1</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_1" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 2</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_2" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 3</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_3" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 4</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_4" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 5</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_5" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Target Tahun 6</label>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.thn_6" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Kondisi Akhir</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="indikator.kondisi_akhir" type="text" class="form-control" placeholder="Ex : ">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button @click="editindikator()" type="submit" class="btn bg-light-blue waves-effect" >SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                           
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_edt_data_indikator_kinerja xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_jml_anggaran_indikatif xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal" id="m_jml_anggaran_indikatif" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-orange">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">ANGGARAN INDIKATIF</h4>
                                    </div>

                                    <div class="modal-body">

                                        <hr>
                                        <button v-on:click='cek_edit_anggaran = !cek_edit_anggaran' class="btn bg-light-blue waves-effect">
                                            <div v-if="!cek_edit_anggaran">
                                                ATUR DATA
                                            </div> 
                                            <div v-if="cek_edit_anggaran">
                                                KEMBALI
                                            </div>    
                                        </button>
                                        <br><br>
                                        <div class="table-responsive">
                                            <table class="table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="bg-orange kepala_table_f tabel_center">
                                                    <th class="tabel_center text-center" rowspan="2" style="width:50%">Uraian</th>
                                                    <th class="tabel_center text-center" rowspan="2" style="width:50%">Jumlah Anggaran (Indikatif)</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 1</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_1" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_1)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 2</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_2" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_2)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 3</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_3" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_3)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 4</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_4" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_4)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 5</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_5" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_5)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 6</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_6" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_6)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <hr>
                                        


                                    </div>
                                    <div class="modal-footer">
                                        <button v-if="cek_edit_anggaran" @click="editAnggaranInstansi()" type="submit" class="btn bg-orange waves-effect" >SIMPAN</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_jml_anggaran_indikatif xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>


<script>

    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL_MISI = URL_APP+'api/v1/planning_misi/';
    const ADD_URL_SASARAN = URL_APP+'api/v1/planning_sasaran_pembangunan/';
    const ADD_URL_URUSAN = URL_APP+'api/v1/planning_urusan/';
    const ADD_URL_BIDANG = URL_APP+'api/v1/planning_bidang/';
    const ADD_URL_PROGRAM = URL_APP+'api/v1/planning_program/';
    const ADD_URL_KEBIJAKAN_UMUM = URL_APP+'api/v1/planning_kebijakan_umum/';
    const ADD_URL_PRIORITAS = URL_APP+'api/v1/planning_prioritas/';
    const ADD_URL_SATKER = URL_APP+'api/v1/planning_satker/';
  
    const ADD_URL = URL_APP+'api/v1/planning_program_pembangunan/';


    export default {
        name: "planning_urusan",
        data() {
            return {

   
                filter_rpjmd: '',
                filter_misi: '',
                filter_sasaran : '',

                rpjmd_id : '',
                rpjmd_periode : '',

                misi_id : '',
                no_misi : '',
                misi_uraian : '',

                sasaran_id : '',
                no_sasaran : '',
                sasaran_uraian : '',

                urusan_pemerintahan_id : '',
                kode_urusan : '',
                nama_urusan : '',

                urusan_pemerintahan_id : '',
                kode_urusan : '',
                nama_urusan : '',

                bidang_urusan_pemerintahan_id : '',
                kode_bidang : '',
                nama_bidang : '',

                program_id : '',
                program_kode : '',
                program_nama : '',

                kebikan_umum_id : '',

                prioritas_id : '',
                prioritas_kode : '',
                prioritas_nama : '',

                program_pembangunan_id : '',
                keterangan : '',
                anggaran : {
                    relasi_program_pembangunan_skpd_id : '',
                    tahun_1 : '',
                    tahun_2 : '',
                    tahun_3 : '',
                    tahun_4 : '',
                    tahun_5 : '',
                    tahun_6 : '',
                },

                instansi_id : '',

                list_data: [],
                list_rpjmd: [],
                list_misi: [],
                list_sasaran : [],
                list_urusan :[],
                list_bidang :[],
                list_program :[],
                list_kebijakan_umum :[],
                list_prioritas :[],
                list_instansi :[],
                list_indikator : [],
                

                pilih_program : [],
                pilih_instansi : [],

                indikator : {
                    indikator_id : '',
                    program_pembangunan_id : '',
                    no_indikator : 0,
                    uraian : '',
                    satuan : '',
                    rumus_satuan : '',
                    capaian_awal : 0,
                    thn_1 : 0,
                    thn_2 : 0,
                    thn_3 : 0,
                    thn_4 : 0,
                    thn_5 : 0,
                    thn_6 : 0,
                    kondisi_akhir : 0,
                },


                cek_sasaran : false,
                cek_edit_anggaran : false,
                cek_load_data : true,


                page_first : 1,
                page_last : 0,
                cari_value : ''
            }
        },

        mounted() {
            this.getData();
            this.getPeriode();
            this.getPrioritas();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {

            getData: function(){
                this.cek_load_data = true;
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                        rpjmd_id : this.filter_rpjmd,
                        misi_id : this.filter_misi,
                        sasaran_id : this.filter_sasaran,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.cek_load_data = false;
                    this.list_data = res_data;
                })
            },
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        misi_id : this.filter_misi,
                        sasaran_id : this.filter_sasaran,
                        urusan_pemerintahan_id : this.urusan_pemerintahan_id,
                        bidang_urusan_pemerintahan_id : this.bidang_urusan_pemerintahan_id,
                        program_id : this.pilih_program

                    })
                }).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });

                // console.log(this.pilih_program);
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        program_pembangunan_id : this.program_pembangunan_id,
                        prioritas_nama : this.prioritas_id,
                        kebikan_umum_id : this.kebikan_umum_id,

                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            removeData : function(id){
                this.$swal({
                title: 'Apa Anda Ingin Menghapus Data?',
                text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                            program_pembangunan_id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                }
                })
            },
            emptyData : function(){
                this.list_kebijakan_umum = [];
                this.list_indikator = [];
                // this.list_sasaran =[];
                this.pilih_program =[];
                this.list_urusan =[];
                this.list_bidang =[];
                this.list_instansi =[];
                this.pilih_instansi = [];


                this.cek_edit_anggaran = false;
            },
            selectData : function(data){
                // console.log(data);
                this.rpjmd_id = data.rpjmd_id;
                this.rpjmd_periode = data.rpjmd_periode;

                this.misi_id = data.misi_id;
                this.no_misi = data.no_misi;
                this.misi_uraian = data.misi_uraian;

                this.arah_kebijakan_id = data.arah_kebijakan_id;
                this.no_arah_kebijakan = data.no_arah_kebijakan;
                this.uraian = data.uraian;
                this.keterangan = data.keterangan;
                this.data = data;   

                this.program_pembangunan_id = data.program_pembangunan_id;
                this.indikator.program_pembangunan_id = data.program_pembangunan_id;
                this.program_id = data.program_id;
                this.bidang_urusan_pemerintahan_id = data.bidang_urusan_pemerintahan_id;
                this.kebikan_umum_id = data.kebikan_umum_id;
                this.prioritas_id = data.prioritas_nama

                this.getInstansi();
                this.getKebijakan_umum();
                this.getindikator();
            },

            addindikator : function(){
                // console.log(this.pilih_instansi);
                fetch(ADD_URL+'createDataIndikator_program_pembangunan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.indikator)
                }).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getindikator();
                    // this.getData();
                });
            },
            editindikator : function(){
                // console.log(this.pilih_instansi);
                fetch(ADD_URL+'updateDataIndikator_program_pembangunan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.indikator)
                }).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getindikator();
                    // this.getData();
                });
            },
            getindikator : function(){
                // console.log(this.pilih_instansi);
                fetch(ADD_URL+'readDataIndikator_program_pembangunan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        program_pembangunan_id : this.program_pembangunan_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.list_indikator = res_data;
                })
            },
            removeIndikator : function(id){
                this.$swal({
                title: 'Apa Anda Ingin Menghapus Data?',
                text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                    fetch(ADD_URL+"deleteDataIndikator_program_pembangunan", {
                        method : 'POST',
                        headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                            indikator_program_pembangunan_id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getindikator();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                }
                })
            },
            selectIndikator: function(data){
                this.indikator = data;
                // console.log(this.indikator);
            },

            addInstansi : function(){
                // console.log(this.pilih_instansi);
                fetch(ADD_URL+'createDatarelasi_program_pembangunan_skpd', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        pilih_instansi : this.pilih_instansi,
                        program_pembangunan_id : this.program_pembangunan_id,
                    })
                }).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            removeIns: function (id) {
                this.$swal({
                title: 'Apa Anda Ingin Menghapus Data ini?',
                text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                    fetch(ADD_URL+"deleteDatarelasi_program_pembangunan_skpd", {
                        method : 'POST',
                        headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                            relasi_program_pembangunan_skpd_id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                }
                })
                // console.log(id);
            },
            
            getInstansi: function(){
                if (this.filter_misi == '') {
                    this.filter_sasaran = '';
                }
                fetch(ADD_URL_SATKER+'getRelasiInstansi', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        program_pembangunan_id : this.program_pembangunan_id,
                        program_id : this.program_id,
                        bidang_urusan_pemerintahan_id : this.bidang_urusan_pemerintahan_id
                    })

                }).then(res => res.json()).then((res_data)=>{
                        // console.log(res_data);
                        this.list_instansi = res_data;
                        // console.log(res_data);
                })
            },

            selectInstansi : function(data){
                // this.anggaran.relasi_program_pembangunan_skpd_id = data.relasi_program_pembangunan_skpd_id
                console.log(data);
                this.anggaran = {
                    relasi_program_pembangunan_skpd_id : data.relasi_program_pembangunan_skpd_id,
                    tahun_1 : data.tahun_1,
                    tahun_2 : data.tahun_2,
                    tahun_3 : data.tahun_3,
                    tahun_4 : data.tahun_4,
                    tahun_5 : data.tahun_5,
                    tahun_6 : data.tahun_6,
                }
            },
            editAnggaranInstansi : function(){
                // console.log(this.pilih_instansi);
                fetch(ADD_URL+'editDatarelasi_program_pembangunan_skpd', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.anggaran)
                }).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                    this.cek_edit_anggaran = false;
                });
            },
            cek_sasaran_add : function(){
                if (this.filter_sasaran == '') {
                    this.cek_sasaran = false;
                }else{
                    this.cek_sasaran = true;
                    this.getUrusan();
                }
            },


            // =================================== TAMBAHAN ==================================
                getPeriode: function(){
                    fetch(ADD_URL_RPJMD, {
                        method : 'GET',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },

                    }).then(res => res.json()).then((res_data)=>{
                        //   console.log(res_data);
                        this.list_rpjmd = res_data
                    })
                },

                getMisi: function(){
                    if (this.filter_rpjmd == '') {
                        this.filter_misi = '';
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_MISI+'misi_id_rpjmd', {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            rpjmd_id : this.filter_rpjmd
                        })

                    }).then(res => res.json()).then((res_data)=>{
                            // console.log(res_data);
                            this.list_misi = res_data
                            this.getData();
                    })
                },

                getSasaran: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_SASARAN+'sasaran_in_arah_kebijakan', {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            misi_id : this.filter_misi
                        })

                    }).then(res => res.json()).then((res_data)=>{
                            // console.log(res_data);
                            this.list_sasaran = res_data
                            this.getData();
                    })
                },

                getUrusan: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_URUSAN, {
                        method : 'GET',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        }

                    }).then(res => res.json()).then((res_data)=>{
                            // console.log(res_data);
                            this.list_urusan = res_data
                    })
                },

                getBidang: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_BIDANG, {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            urusan_pemerintahan_id : this.urusan_pemerintahan_id
                        })

                    }).then(res => res.json()).then((res_data)=>{
                            // console.log(res_data);
                            this.list_bidang = res_data;
                    })
                },

                getProgram: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_PROGRAM, {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            bidang_urusan_pemerintahan_id : this.bidang_urusan_pemerintahan_id,
                            sasaran_id : this.filter_sasaran
                        })

                    }).then(res => res.json()).then((res_data)=>{
                            // console.log(res_data);
                            this.list_program = res_data;
                            // this.getPrioritas();
                    })
                },
                getKebijakan_umum: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_KEBIJAKAN_UMUM+'program_pembangunan', {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            misi_id : this.misi_id,
                        })

                    }).then(res => res.json()).then((res_data)=>{
                            this.list_kebijakan_umum = res_data;
                            // console.log(res_data);
                    })
                },
                getPrioritas: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_PRIORITAS, {
                        method : 'GET',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        }

                    }).then(res => res.json()).then((res_data)=>{
                            // console.log(res_data);
                            this.list_prioritas = res_data
                            // this.prioritas_id[0] = res_data[0].prioritas_id

                            var program = this.list_program;

                            // for (let i = 0; i < program.length; i++) {
                            //     this.prioritas_id[i] = res_data[0].prioritas_id;
                            //     // console.log(i);
                            // }

                    })
                },
                

                


            // =================================== TAMBAHAN ==================================


            // =================================== PAGINASI ==================================
                alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
                },

                btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
                },

                btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
                },

                cari_data : function(){
                    this.page_first = 1;
                    this.getData();
                },
                format_uang : function(angka, prefix){
                    var rupiah = '';		
                    var angkarev = angka.toString().split('').reverse().join('');
                    for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
                    return ''+rupiah.split('',rupiah.length-1).reverse().join('');
                },


            // =================================== PAGINASI ==================================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
